/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * A service which handles auto saving of domain entities and publishing associated events.
 */
angular.module('bulbApp.autoSaveModule')
  .service('BulbAutoSaveService', [
    '$rootScope',
    'Restangular',
    'ErrorService',
    'SaveStateStore',
    'SerialSaveService',
    'UnitStateStore',
    '_',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    BulbAutoSaveService]);

function BulbAutoSaveService(
  $rootScope,
  Restangular,
  ErrorService,
  SaveStateStore,
  SerialSaveService,
  UnitStateStore,
  _,
) {

  // Instance of restangular which includes the full response, even for successful saves.
  const RestangularFull = Restangular.withConfig((RestangularConfigurer) => {
    RestangularConfigurer.setFullResponse(true);
  });

  /**
   * Save helper that handles content revision logic to help prevent saves from overwriting each other.
   *
   * Auto saves are considered to be 'edits' to the unit, and the unit share status will be updated appropriately.
   *
   * @param id Id of the entity to save.
   * @param collection Collection which stores the entity.
   * @param payload Payload object to be saved.
   * @param callback Function to callback after a successful save.
   * @return {*} Promise representing the save.
   */
  this.autoSave = function autoSave(id, collection, payload, callback) {
    // create a clone of the payload, so we can add the revision to it without altering the original
    const localPayload = _.cloneDeep(payload);

    const restangular = RestangularFull.one(collection, id);
    return SerialSaveService.save({
      // eslint-disable-next-line arrow-body-style
      save: () => {
        // Set revision in payload to assure that page content is not lost.
        if ($rootScope.revision && $rootScope.revision.id === id && collection === 'units') {
          localPayload.rev = $rootScope.revision.rev;
        }

        // FUTURE: remove 'units' code when we no longer need it (when we have fully REST-ful 'units')
        return (collection === 'units') ? restangular
          .customPOST(localPayload, 'update') : restangular.patch(localPayload);
      },
    }).then((response) => {
      // update root stored revision if returned by the save
      if (typeof response.data !== 'undefined') {
        // eslint-disable-next-line no-param-reassign
        $rootScope.revision = { id: response.data.id, rev: response.data.rev };
      }

      if (callback) {
        callback(response.data);
      }

      const ShareTransition = UnitStateStore.getShareTransitionEnum();
      UnitStateStore.transitionShareStatus(ShareTransition.EDIT);

      // If the is 205 Reset Content, we want to force the user to refresh because something was wrong with the save,
      // but the save was successful.
      if (response.status === 205) {
        // Capture an error, so we can use the bread crumbs to try to figure out what might have caused the issue.
        ErrorService.captureErrorMessage('Reset Client after save of page', { pageId: id });

        // Prevent further edits by forcing a refresh.
        const statusEnum = SaveStateStore.getStatusEnum();
        SaveStateStore.setStatus(statusEnum.ERROR);
      }
    });
  };

}
